import { TranslatedProperty } from "./translate-property.model";
import { ResourceParameter } from "./resource-parameter.model";
import { Actions } from "./action.model";
import { MainModel } from "src/app/models/auth/_models/main-model";

export class MicroApplication {

  constructor() {
    this.id = {};
    this.code = "";
    this.type = 0;
    this.name = { esCO: "", enUS: "", ptBR: "" };
    this.description = { esCO: "", enUS: "", ptBR: "" };
    this.category = "";
    this.url = "";
    this.snapShotUrl = "";
    this.icon = "";
    this.useTitleHeader = "";
    this.multiInstance = false;
    this.parameters = [];
    this.actions = [];
    this.visible = true;
    this.tags = [];
    this.applicationMenu = new MainModel();
    this.widgetData = new Widget();
    this.link=[];
  }


  
  id: any;
  code: string;
  type: number;
  name: TranslatedProperty;
  description: TranslatedProperty;
  category: string;
  treeListCategory: string;
  url: string;
  snapShotUrl: string;
  icon: string;
  useTitleHeader: string;
  multiInstance: boolean;
  parameters: ResourceParameter[];
  actions: Actions[];
  visible: boolean;
  tags: string[];
  applicationMenu: MainModel;
  widgetData:Widget;
  link:Linkdata[];

}
export class  Linkdata 
{
     __KEY__ : string; 
    code : string;
    description : string;
    microApplication_Id : string

};
export class ApplicationMenu {
  code: string;
  name: string;
}

export class widgetdata {
  code: string;
  name: string;
}

export class Widget {
constructor(){
 
}
   columns:number;
   height:number;
   order:number;

}